import React, { createContext, useContext, useEffect, useRef, useState } from "react"
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { defPath } from '../config/defPath'
import { fetchPath } from '../config/defPath'
import { Switch, Route, Link, useRoute } from 'wouter';
import { Controls } from "../components/layout/menu_help"
import { useFetch } from "../hooks/useFetch";
import type { RankingResponse, PremiosResponse, Ranking, PremiosData, SliderPremiosProps, Premio } from "../config/types/rankingApi"
import type { CardRankingProps, CardPremioProps, NavLinkProps, NavMenuProps } from "../config/types/components"
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useRanking, useSession } from "../hooks/useState"
import "swiper/css";
import "swiper/css/navigation";
import Avatar3D from "./ranking3D"
import { page } from "../pages/ranking3D"
import { formatDate } from "../../utils/formatDate"
import { wordToCapital } from "../../utils/capitalWord"
import ThemeContext from "../contexts/themeContext"

export default function Ranking() {
  const theme = useContext(ThemeContext);

  const updatePoints = useSession(state => state.updatePoints)
  const [menuVisible, setMenuVisible] = useState(false)
  const [isPremios] = useRoute('/estadio-aguila/premios');

  const { data: dataRanking, isLoading: loadingRanking }: RankingResponse = useFetch(`${fetchPath}/aguila/loyalty/ranking`, 'POST')
  const { data: dataProgress, isLoading: loadingProgress }: PremiosResponse = useFetch(`${fetchPath}/aguila/loyalty/assets/ranking`, 'POST')
  const myPosition = dataRanking &&
    dataRanking?.response[0]?.my_ranking
    ? dataRanking?.response[0]?.my_ranking[0].position
    : null

  const toggleMenu = () => {
    setMenuVisible(!menuVisible)

    let isMenuShow = menuVisible ? 'Close menu' : 'Open menu'
    let action = menuVisible ? 'Cerrar' : 'Menú'

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Card',
      'event_label': `${isMenuShow} - Ranking and prizes`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_RankingandPrizes',
      'element_text': `${action}`,
    });
  }

  const toggleItemMenu = (item: any) => {
    setMenuVisible(!menuVisible)
  }

  useEffect(() => {
    window.matchMedia("(min-width: 991px)").matches && page()    
  }, [])

  useEffect(() => {
    if(dataRanking && dataRanking.response[0]?.my_ranking) updatePoints(parseInt(dataRanking.response[0]?.my_ranking[0]?.points) || 0);
  },[dataRanking])

  return (
    <ThemeContext.Provider value={theme}>
      <section id='game-ranking' className={`ar__ranking ${theme === 'none' ? '' : 'america__cup'}`}>
        {theme === 'none' ? <NewHeader /> : <NewHeader logo={`${defPath}/assets/images/ranking/aguila_logo.png`} />}
        <Modal />
        <Controls isStadium={false} />

        {theme === 'none'
          ? <>
            <BackgroundRanking />

            {window.matchMedia("(min-width: 991px)").matches &&
              <div className={`ar__ranking--canvas ${isPremios ? '' : 'is-visible'} `}>
                <Avatar3D />
              </div>}
          </>
          : <>
            <picture>
              <source media="(min-width: 640px)" srcSet={`${defPath}/assets/images/ranking/bg_ranking_desk.png`} />
              <img className="america__cup--bg" src={`${defPath}/assets/images/ranking/bg_ranking_mob.png`} alt="" title="" />
            </picture>
            {window.matchMedia("(min-width: 991px)").matches &&
              <div className={`ar__ranking--canvas ${isPremios ? '' : 'is-visible'} `}>
                <figure className="ar__ranking--canvas-image">
                  <img src={`${defPath}/assets/images/ranking/ranking_large_flag.png`} alt="" title="" />
                </figure>
              </div>}
          </>}

        <NavMenu menuVisible={menuVisible} toggleMenu={toggleMenu}>
          <NavLink href="/estadio-aguila/ranking" toggleMenu={() => toggleItemMenu('Ranking')} >Ranking</NavLink>
          <NavLink href="/estadio-aguila/premios" toggleMenu={() => toggleItemMenu('Premios')} >Premios</NavLink>
          {theme === 'none' && <NavLink href="/estadio-aguila/progreso" toggleMenu={() => toggleItemMenu('Mi Progreso')} >Mi Progreso</NavLink>}
        </NavMenu>

        <Switch>
          <Route path="/estadio-aguila/ranking">
            <RankingComponent data={dataRanking} isLoading={loadingRanking} />
          </Route>
          <Route path="/estadio-aguila/premios">
            <PremiosComponent data={dataProgress} myPosition={myPosition} isLoading={loadingProgress} />
          </Route>
          <Route path="/estadio-aguila/progreso">
            <ProgresoComponent data={dataRanking} isLoading={loadingRanking} />
          </Route>
        </Switch>

      </section>
    </ThemeContext.Provider>
  )
}

function RankingComponent({ data, isLoading }: RankingResponse) {
  const [cardOpen, setCardOpen] = useState("Goleadores")

  if (isLoading) return <span></span>

  let rankingList: any = []
  // let fechaFormateada = ''
  let fechaDescripcion = ''
  let rankingUser: any = []
  // const dateStart = data.response["config"]?.date_start_week
  // const dateEnd = data.response["config"]?.date_end_week

  // const fechaStart = new Date(dateStart);
  // const fechaEnd = new Date(dateEnd);

  if (!data.response) {
    // fechaFormateada = `${formatDate(fechaStart)} a ${formatDate(fechaEnd)} del 2023`;
    fechaDescripcion = 'proximamente'
    rankingList = []
    rankingUser = []
  } else {
    fechaDescripcion = data.response["config"]?.description || 'proximamente'
    rankingList = data.response[0]?.ranking || []
    rankingUser = data.response[0]?.my_ranking || []
  }

  return <>
    <div className="ar__ranking__content blur-in">
      <div className="ar__ranking__header">
        <div className="ar__ranking__title whiteShadow">Ranking</div>
      </div>

      <div className="ar__ranking__content-scroll scrollBar">
        <div className="ar__ranking__content-inner">
          <div className="ar__ranking__box">
            <div className="ar__ranking__box__weeks">
              {/* {fechaFormateada.length > 0 ? fechaFormateada : 'Proximamente'} */}
              {fechaDescripcion}
            </div>
            <CardRanking name='Goleadores' listWinner={rankingList.slice(0, 3)} posi={1} first={true} cardOpen={cardOpen} setCardOpen={setCardOpen} />
            <CardRanking name='Títulares' listWinner={rankingList.slice(3, 7)} posi={4} position={'75%'} cardOpen={cardOpen} setCardOpen={setCardOpen} />
            <CardRanking name='Suplentes' listWinner={rankingList.slice(7, 11)} posi={8} position={'50%'} cardOpen={cardOpen} setCardOpen={setCardOpen} />
            <CardRanking name='Canteranos' listWinner={rankingList.slice(11, 15)} posi={12} position={'25%'} cardOpen={cardOpen} setCardOpen={setCardOpen} />
            <CardRanking name='Nivel 0' listWinner={rankingList.slice(15)} posi={16} position={'0%'} cardOpen={cardOpen} setCardOpen={setCardOpen} />
          </div>
        </div>
      </div>
      <div className="ar__ranking__content-canvas"></div>
    </div>
    {data.response[0]?.my_ranking ? <UserInfo data={rankingUser[0]} nameTag="Ranking" /> : <NoData />}
  </>
}

function PremiosComponent({ data, isLoading, myPosition }: PremiosResponse) {
  const [showModal, setShowModal] = useState(false)
  const [cardActive, setCardActive] = useState<{} | null>(null)

  const award = useRanking(state => state.award)

  useEffect(() => {
    if (award) {
      const el = document.querySelector(`[data-ini="${award.ini}"]`) as HTMLElement
      if (el) {
        const cta = el.querySelector('.ar__premios__card__list__item__cta') as HTMLElement
        const card = el.closest('.ar__premios__card') as HTMLElement
        const header = card && card.querySelector('.ar__premios__card__header') as HTMLElement
        cta && cta.click()
        header && header.click()
      }
    }
  }, [])

  const toggleModal = (card: any) => {
    setShowModal(!showModal)
    setCardActive(card)
  }

  if (isLoading) return <span></span>

  return (
    <>
      <div className="ar__ranking__content blur-in">
        <div className="ar__ranking__header">
          <div className="ar__ranking__title whiteShadow">Premios</div>
        </div>

        <div className="ar__ranking__content-scroll scrollBar">
          <div className="ar__ranking__content-inner">
            <CardPremios name={`goleador`} listPremios={data.goleador} first={!Boolean(award)} position={myPosition} toggleModal={toggleModal} cardActive={cardActive} />
            <CardPremios name={`titular`} listPremios={data.titular} imagePosition={'75%'} position={myPosition} toggleModal={toggleModal} cardActive={cardActive} />
            <CardPremios name={`suplente`} listPremios={data.suplente} imagePosition={'50%'} position={myPosition} toggleModal={toggleModal} cardActive={cardActive} />
            <CardPremios name={`canterano`} listPremios={data.canterano} imagePosition={'25%'} position={myPosition} toggleModal={toggleModal} cardActive={cardActive} />
            <CardPremios name={`nivel 0`} listPremios={data.nivel0} imagePosition={'0%'} position={myPosition} toggleModal={toggleModal} cardActive={cardActive} />
          </div>
        </div>
      </div>

      <SliderPremios showModal={showModal} toggleModal={toggleModal} dataApi={data} cardActive={cardActive} />
    </>
  )
}

function ProgresoComponent({ data, isLoading }: RankingResponse) {
  const { data: dataProgress, isLoading: loading }: any = useFetch(`${fetchPath}/aguila/loyalty/user-progress`, 'POST')

  const setAward = useRanking(state => state.setAward)

  if (isLoading) return <span></span>
  if (loading) return <span></span>

  const rankingUser = data.response[0]?.my_ranking
  const currentAward = rankingUser ? rankingUser[0]?.award : null

  const handleSeeDetailBtn = (e: any) => {

    if (data.response[0].my_ranking[0].award?.ini) {
      setAward(data.response[0].my_ranking[0].award)
    }

    const card = e.currentTarget?.closest(".ar__progress__current")
    const award = card?.querySelector(".ar__progress__current--title")?.textContent

    if (award === undefined) {
      var copyDatalayer = 'My Progress'
    }
    else {
      var copyDatalayer = `${award} - My Progress`
    }

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': copyDatalayer,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_RankingandPrizes',
      'element_text': e.currentTarget?.textContent,
    });
  }

  const handlePlayBtn = (e: any) => {
    e.preventDefault()

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Game now - My Progress',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_RankingandPrizes',
      'element_text': e.currentTarget?.textContent,
    });

    if (e.target.href) window.location.href = e.target.href
  }

  return <>
    <div className="ar__ranking__content blur-in">
      <div className="ar__ranking__header">
        <div className="ar__ranking__title whiteShadow">Progreso</div>
      </div>

      <div className="ar__ranking__content-scroll scrollBar myprogress">
        <div className="ar__ranking__content-inner">
          {!dataProgress ? (
            <>
              <div className="ar__ranking__noData">
                <div className="ar__ranking__noData--title whiteShadow">No hay <br /> datos para el <br /> ranking</div>
                <div className="ar__ranking__noData--subtitle">Te invitamos a participar en nuestras dinámicas, acumula puntos y participa por premios</div>
                <a href="/estadio-aguila/juego" className="ar__btn-primary ar__ranking__noData--btn" onClick={(e) => handlePlayBtn(e)}>Jugar Ahora</a>
              </div>
            </>
          ) : (
            <>
              {
                currentAward ? (
                  <div className="ar__progress__current">
                    <picture className="ar__progress__current--picture">
                      <img className="ar__progress__current--img" src={currentAward.image.imgurl_raw} alt={currentAward.image.img_alt} title={currentAward.image.img_alt} />
                    </picture>
                    <div className="ar__progress__current--subtitle">
                      <span>Mi PREMIO ACTUAL</span>
                    </div>
                    <div className="ar__progress__current--title" dangerouslySetInnerHTML={{ __html: currentAward.title }} ></div>
                    <Link to='/estadio-aguila/premios' onClick={(e) => handleSeeDetailBtn(e)}>
                      <a className="ar__progress__current--link" href="#" >Ver detalles</a>
                    </Link>
                  </div>
                ) : (
                  <div className="ar__ranking__noData not-award">
                    <div className="ar__ranking__noData--title whiteShadow">Gana <br />experiencias únicas </div>
                    <div className="ar__ranking__noData--subtitle">Te invitamos a participar en nuestras dinámicas y acumular puntos para participar por premios increíbles</div>
                    <a href="/estadio-aguila/juego" className="ar__btn-primary ar__ranking__noData--btn" onClick={(e) => handlePlayBtn(e)}>Jugar Ahora</a>
                  </div>
                )
              }
              <div className="ar__progress__stats-row">
                <div className="ar__progress__stats">
                  <div className="ar__progress__stats--card">
                    <img className="ar__progress__stats--card--img" src={`${defPath}/assets/images/ranking/stats_partidos.png`} alt="stats icon" title="stats icon" />
                    <div className="ar__progress__stats--card--data">
                      <div className="ar__progress__stats--card--data--number">{dataProgress.futbolin}</div>
                      <div className="ar__progress__stats--card--data--name">PARTIDOS JUGADOS en futbolín</div>
                    </div>
                  </div>
                  <div className="ar__progress__stats--card">
                    <img className="ar__progress__stats--card--img" src={`${defPath}/assets/images/ranking/stats_predicciones.png`} alt="stats icon" title="stats icon" />
                    <div className="ar__progress__stats--card--data">
                      <div className="ar__progress__stats--card--data--number">{dataProgress.predicciones}</div>
                      <div className="ar__progress__stats--card--data--name">PREDICCIONES <br /> DE PARTIDOS</div>
                    </div>
                  </div>
                </div>
                <div className="ar__progress__stats">
                  <div className="ar__progress__stats--card">
                    <img className="ar__progress__stats--card--img" src={`${defPath}/assets/images/ranking/stats_retos.png`} alt="stats icon" title="stats icon" />
                    <div className="ar__progress__stats--card--data">
                      <div className="ar__progress__stats--card--data--number">{dataProgress.retos}</div>
                      <div className="ar__progress__stats--card--data--name">RETOS SEMANALES COMPLETADOS</div>
                    </div>
                  </div>
                  <div className="ar__progress__stats--card">
                    <img className="ar__progress__stats--card--img" src={`${defPath}/assets/images/ranking/stats_redenciones.png`} alt="stats icon" title="stats icon" />
                    <div className="ar__progress__stats--card--data">
                      <div className="ar__progress__stats--card--data--number">{dataProgress.tada}</div>
                      <div className="ar__progress__stats--card--data--name">Redenciones <br /> TADA</div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="ar__ranking__content-canvas">
      </div>
    </div>

    {
      dataProgress && data.response[0]?.my_ranking && <UserInfo data={rankingUser[0]} nameTag="My Progress" />
    }

  </>
}
``
function ArrowToggle({ color = '#fff' }) {
  return (
    <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.3984 11.8606L2.20282 2.62207" stroke={color} strokeWidth="3.69405" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.6641 2.62207L11.4684 11.8606" stroke={color} strokeWidth="3.69405" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function BackgroundRanking() {
  return <>
    <picture className="ar__ranking__bg">
      <source media="(min-width: 767px)" srcSet={`${defPath}/assets/images/ranking/bg_texture.png`} />
      <img src={`${defPath}/assets/images/ranking/bg_texture.png`} alt="Background ranking" title="Background ranking" />
    </picture>
    <picture className="ar__ranking__bg--top">
      <img src={`${defPath}/assets/images/ranking/bg_texture_top.png`} alt="Background ranking" title="Background ranking" />
    </picture>
    <picture className="ar__ranking__bg--bottom">
      <source media="(min-width: 767px)" srcSet={`${defPath}/assets/images/ranking/bg_ranking_desktop.png`} />
      <img src={`${defPath}/assets/images/ranking/bg_texture_bottom.png`} alt="Background ranking" title="Background ranking" />
    </picture>
  </>
}

const NavLink: React.FC<NavLinkProps> = ({ href, children, toggleMenu }) => {
  const [isActive] = useRoute(href);

  const handleOptionsMenuClick = (e: any) => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${e.currentTarget?.textContent} - Ranking and prizes`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_RankingandPrizes',
      'element_text': e.currentTarget?.textContent,
    });
  }

  return (
    <Link to={href} onClick={toggleMenu}>
      <a className={`tab__head ${isActive && 'tab__head--active'}`}>
        <span className="black_30 blueDark" onClick={(e) => handleOptionsMenuClick(e)}>{children}</span>
      </a>
    </Link>
  );
};

const NavMenu: React.FC<NavMenuProps> = ({ children, menuVisible, toggleMenu }) => {

  return <>
    <button onClick={toggleMenu} className={`ar__ranking__nav--menu ${menuVisible ? 'hide' : ''}`}>
      <img src={`${defPath}/assets/images/icons/icon_menu.svg`} alt="Background ranking" title="Background ranking" width={28} height={28} />
    </button>
    <div className={`ar__ranking__nav ${menuVisible ? 'is-visible' : ''}`}>
      <img onClick={toggleMenu} className="ar__ranking__nav--close" src={`${defPath}/assets/images/icons/icon_xclose.png`} alt="Background ranking" title="Background ranking" />

      <div className="tab__list">
        {children}
      </div>
    </div>
  </>
}

function CardPremios({ name, listPremios, first, position, imagePosition, toggleModal, cardActive }: CardPremioProps) {
  const isDesktop = window.matchMedia("(min-width: 991px)").matches
  const theme = useContext(ThemeContext);

  useEffect(() => {
    const cards = document.querySelectorAll('.ar__ranking__content-inner .ar__premios__card')

    if (!cardActive) {
      cards[0].classList.add('isShow')
      return
    }

    cardActive && cardActive?.name === 'goleador'
      ? cards[0].classList.add('isShow')
      : cardActive?.name === 'titular'
        ? cards[1].classList.add('isShow')
        : cards[2].classList.add('isShow')
  }, [])

  const handleClick = (e: any, index: number) => {
    toggleModal && toggleModal({ name, index })

    const cards = document.querySelectorAll('.ar__ranking__content-inner .ar__premios__card')

    cards?.forEach(card => card.classList.remove('isShow'))

    e.currentTarget?.classList.add('isShow')
    const item = e.currentTarget?.closest(".ar__premios__card__list__item")
    const award = item?.querySelector(".ar__premios__card__list__item__name")?.textContent

    // window.dataLayer.push({
    //   'event': 'GAEvent',
    //   'event_category': 'Content',
    //   'event_action': 'Card',
    //   'event_label': `${award} - Prizes`,
    //   'interaction': 'true',
    //   'component_name': 'Modo_Carrera_RankingandPrizes',
    //   'element_text': e.currentTarget?.textContent,
    // });
  }

  useEffect(() => {
    const cards = document.querySelectorAll('.ar__ranking__content-inner .ar__premios__card')

    if (position) {
      position <= 3 ? positionDisplay(cards[0]) :
        position <= 7 ? positionDisplay(cards[1]) :
          position <= 11 ? positionDisplay(cards[2]) :
            position <= 15 ? positionDisplay(cards[3]) :
              position <= 20 ? positionDisplay(cards[4]) :
                ''
    }


    function positionDisplay(card: any) {
      const myPositionText = card.querySelector('.brush_text_white')

      myPositionText.textContent = 'Tu nivel:'
      card.classList.add('myPosition')
    }
  }, [position])

  useEffect(() => {
    first && isDesktop && toggleModal && toggleModal({ name: 'goleador', index: 0 })
  }, [isDesktop])

  return <>
    <div onClick={(e) => handleClick(e, 0)} className={`ar__premios__card`}>
      {theme === 'none'
        ? <img className="ar__premios__card__logo" style={{ objectPosition: imagePosition || '100%' }} src={`${defPath}/assets/images/ranking/ranking_logo.png`} alt="ranking logo" title="ranking logo" />
        : <img className="ar__premios__card__logo" src={`${defPath}/assets/images/ranking/ranking_flag.png`} alt="ranking logo" title="ranking logo" />
      }
      <div className="ar__premios__card__header">
        <div className="bg_brush_blue">
          <p className="brush_text_white">Nivel:</p>
          <p className="brush_text_yellow">{name === 'nivel 0' ? '0' : name}</p>
        </div>
        <div className="ar__premios__position">ver detalle <ArrowToggle color={theme === 'none' ? '#fff' : '#103EFF'} /> </div>
      </div>
    </div></>
}

interface filterDataProps extends Premio {
  category: string
  index: number
}

type Category = "goleador" | "titular" | "suplente" | "canterano" | "nivel0"

function SliderPremios({ showModal, toggleModal, dataApi, cardActive }: SliderPremiosProps) {
  const theme = useContext(ThemeContext);
  const refSlider = useRef<any>(null)
  const handleClick = () => {
    toggleModal()

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Card',
      'event_label': 'Close - Prizes',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_RankingandPrizes',
      'element_text': 'Cerrar',

    });

  }

  const filterData: filterDataProps[] = Object.keys(dataApi).reduce((acc: filterDataProps[], cat) => {
    dataApi[cat as Category].forEach((item: Premio, index: number) => {
      acc.push({
        ...item,
        category: cat,
        index
      });
    });
    return acc;
  }, []);

  useEffect(() => {
    const indexActive = cardActive && filterData.findIndex((item) => {
      return item.category === cardActive.name.replace(/\s+/g, '') && item.index === cardActive.index
    })
    // @ts-ignore
    indexActive >= 0 && refSlider.current && refSlider.current.swiper.slideTo(indexActive)

    if (filterData[indexActive]?.title) {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': `${filterData[indexActive]?.title.replace(/(<([^>]+)>)/ig, "").replace(/[\n\r]/g, "")} - Prizes`,
        'interaction': 'true',
        'component_name': 'Modo_Carrera_RankingandPrizes',
        'element_text': "Ver Detalle",
      });
    }
  }, [cardActive])



  // console.log('filter',filterData);

  // useEffect(() => {
  //   if (refSlider.current) {
  //     const nextBtn = refSlider.current.querySelector(".swiper-button-next")
  //     const prevBtn = refSlider.current.querySelector(".swiper-button-prev")

  //     nextBtn?.addEventListener('click', (e: any) => {
  //       window.dataLayer.push({
  //         'event': 'GAEvent',
  //         'event_category': 'Content',
  //         'event_action': 'Card',
  //         'event_label': 'Next - Prizes',
  //         'interaction': 'true',
  //         'component_name': 'Modo_Carrera_RankingandPrizes',
  //         'element_text': 'Next',
  //       });
  //     })

  //     prevBtn?.addEventListener('click', (e: any) => {
  //       window.dataLayer.push({
  //         'event': 'GAEvent',
  //         'event_category': 'Content',
  //         'event_action': 'Card',
  //         'event_label': 'Preview - Prizes',
  //         'interaction': 'true',
  //         'component_name': 'Modo_Carrera_RankingandPrizes',
  //         'element_text': 'Preview',
  //       });
  //     })
  //   }
  // }, [])

  return (
    <>
      <div className={`slider_container ${showModal ? 'is-visible' : ''}`} >
        <div className="slider_container--header">
          <div className="header--olas">
            <img src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} loading="lazy" alt="Imagen olas" />
            <img src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} loading="lazy" alt="Imagen olas" />
          </div>
          <a href="/estadio" className="header--logo">
            {theme === 'none'
              ? <img src={`${defPath}/assets/images/logo_aguila_new.png`} loading="lazy" alt="Logo Estadio Aguila" />
              : <img src={`${defPath}/assets/images/ranking/aguila_logo.png`} loading="lazy" alt="Logo Estadio Aguila" />
            }
          </a>
          <a className="header--close" onClick={handleClick}>
            <img className="header--close--icon" src={`${defPath}/assets/images/icons/icon_xclose.png`} alt="Background ranking" title="Background ranking" />
          </a>
        </div>


        <Swiper navigation={true} spaceBetween={50} modules={[Navigation]} ref={refSlider} className="SwiperSliderPremios">

          {
            filterData.map((item, index) => (
              <SwiperSlide key={`${item.place}-${index}`}>
                <div className="slide__premio" data-index={index} >
                  <picture className="slide__premio--picture">
                    <img className="slide__premio--img" src={`${item.image.imgurl_raw}`} alt="premio" title="premio" />
                  </picture>
                  <p className="slide__premio--subtitle">{item.place}</p>
                  <div className="slide__premio--title" dangerouslySetInnerHTML={{ __html: item.quantity }} ></div>
                  <p className="slide__premio--textTitle" >{item.title?.replace(/(<([^>]+)>)/ig, "").replace(/[\n\r]/g, "")}</p>
                  <div className="slide__premio--text" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                </div>
              </SwiperSlide>
            ))
          }

        </Swiper>
      </div>
    </>
  )
}

function CardRanking({ name, listWinner, posi, first, position, setCardOpen, cardOpen }: CardRankingProps) {
  const theme = useContext(ThemeContext);
  const handleClickSeeWinners = () => {
    setCardOpen(name)
  }

  return (
    <>
      <div className={`ar__ranking__card ${first ? 'first-card' : ''} ${cardOpen === name && 'isOpen'}`}>
        {theme === 'none'
          ? <img className="ar__ranking__card__logo" style={{ objectPosition: position || '100%' }} src={`${defPath}/assets/images/ranking/ranking_logo.png`} alt="ranking logo" title="ranking logo" />
          : <img className="ar__ranking__card__logo" src={`${defPath}/assets/images/ranking/ranking_flag.png`} alt="ranking logo" title="ranking logo" />
        }
        <div className="ar__ranking__card__header">
          <div className={`${first ? 'bg_brush_red' : 'bg_brush_blueLight'}`}>
            <p className="brush_text_yellow">{name}</p>
          </div>
          <Link to="/estadio-aguila/premios">
            <button className="bg_brush_blue"><p className="bg_brush_blue_text">Ver Premios</p></button>
          </Link>
          <div className="ar__ranking__card__hinchas" onClick={() => handleClickSeeWinners()}>
            <ArrowToggle color={theme === 'none' ? '#fff' : '#103EFF'} />
          </div>
        </div>
        <div className={`ar__ranking__card__list`}>
          {
            listWinner.map((item, index) =>
              item && (
                <div className={`ar__ranking__card__list__item`} key={`${item.name} ${index}`}>
                  <div className="ar__ranking__card__list__item__position">{index + posi}°</div>
                  <div className="ar__ranking__card__list__item__name">{wordToCapital(item.name)}</div>
                  <div className="ar__ranking__card__list__item__value">{item.points}<span>pts</span></div>
                </div>)
            )
          }
        </div>
      </div>
    </>)
}

function UserInfo({ data, nameTag }: { data: Ranking, nameTag: string }) {
  const theme = useContext(ThemeContext);
  const [info, setInfo] = useState({
    status: 'goleador',
    positionLogo: '100%',
  })
  const [positionMessage, setPositionMessage] = useState({ status: 'up', message: 'Mantuvo su posición del ranking' })


  if (!data) return <span></span>


  useEffect(() => {
    if (data.position) {
      const { difference } = calcularDiferencia(data.position)
      setPositionMessage(statusPosition(difference))
    }
  }, [])

  useEffect(() => {
    data.position <= 3 ? setInfo({ status: 'Goleador', positionLogo: '100%' }) :
      data.position <= 7 ? setInfo({ status: 'Titular', positionLogo: '75%' }) :
        data.position <= 11 ? setInfo({ status: 'Suplente', positionLogo: '50%' }) :
          data.position <= 15 ? setInfo({ status: 'Canterano', positionLogo: '25%' }) :
            data.position <= 20 ? setInfo({ status: 'Nivel 0', positionLogo: '0%' }) :
              setInfo({ status: '', positionLogo: '0%' })
  }, [data])

  const handleSeeAwardClick = (e: any) => {
    const card = e.currentTarget.closest(".userInfo")
    const awardPosition = card.querySelector(".userInfo__below--position .userInfo__below--position__text")?.textContent

    if (awardPosition === undefined) {
      var copyDatalayer = `${nameTag}`
    }
    else {
      var copyDatalayer = `${awardPosition} - ${nameTag}`
    }
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': copyDatalayer,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_RankingandPrizes',
      'element_text': e.currentTarget.textContent,
    });
  }

  const handlePlayBtn = (e: any) => {
    e.preventDefault()

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Game now - My Progress',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_RankingandPrizes',
      'element_text': e.currentTarget?.textContent,
    });

    if (e.target.href) window.location.href = e.target.href
  }

  return <>
    <div className="userInfo">

      <div className="userInfo__cat">
        {
          data.position >= 1 && data.position <= 20 && (
            <div className="userInfo__cat--position">
              <span className="userInfo__cat--position__text whiteShadoe">{info.status}</span>
              {
                theme === 'none'
                ? <img className="userInfo__cat--position__logo" style={{ objectPosition: info.positionLogo }} src={`${defPath}/assets/images/ranking/ranking_logo.png`} alt="ranking logo" title="ranking logo" />
                : <img className="userInfo__cat--position__logo" src={`${defPath}/assets/images/ranking/ranking_flag.png`} alt="ranking logo" title="ranking logo" />
              }
            </div>
          )
        }
      </div>

      <div className="userInfo__progress"> {/* brush white / red */}
        <div className="userInfo__progress--points">
          <span className="userInfo__progress--points-label">Tú puntaje</span>
          <div className="userInfo__progress--points-number">{data.points}</div>
        </div>
        <div className={`userInfo__progress--position ${positionMessage.status === 'up' ? 'green' : 'red'}`}> {/* brush red / green */}
          <span className="userInfo__progress--myposition whiteShadow">{data.position}°</span>
          <img className="userInfo__progress--icon" src={`${defPath}/assets/images/ranking/arrow_up.svg`} alt="arrow_up" title="arrow_up" />
        </div>
      </div>

      <span className="userInfo__status">{positionMessage.message}</span>

      {theme === 'none'
        ? <div className="userInfo__cta">
          {!document.querySelector('.ar__ranking__noData--btn') && <a href="/estadio-aguila/juego" onClick={(e) => handlePlayBtn(e)} className="ar__btn-primary">Jugar Ahora</a>}
        </div>
        : <div className="userInfo__cta">
          {!document.querySelector('.ar__ranking__noData--btn') && <a href="/copa-america/predicciones" className="ar__btn-primary">Predecir camisetas</a>}
        </div>
      }

      <Link
        to="/estadio-aguila/premios"
        className="userInfo__below-link"
        onClick={(e) => handleSeeAwardClick(e)}
      >Ver premios</Link>

    </div>

  </>
}

function NoData() {
  const logged = useSession(state => state.logged)
  const theme = useContext(ThemeContext);
  return (
    <div className="noData">
      <div className="noData__brush"> {/* brush white / red */}
        <p className="noData__brush--title whiteShadow">No hay datos para ranking</p>
        <p className="noData__brush--text">Te invitamos a participar en nuestras dinámicas, <br />acumula puntos y participa por premios</p>
      </div>
      <div className="noData__cta">
        {logged && theme === 'none' && <a href="/estadio-aguila/juego" className="ar__btn-primary">Jugar Ahora</a>}
        {!logged && theme === 'none' && <a href="/estadio-aguila/registro" className="ar__btn-primary">Registrate</a>}

        {logged && theme !== 'none' && <a href="/copa-america/predicciones" className="ar__btn-primary">Predecir camisetas</a>}
        {!logged && theme !== 'none' && <a href="/copa-america/predicciones" className="ar__btn-primary">Predecir camisetas</a>}
      </div>
    </div>
  )
}

function calcularDiferencia(currentPosition: number) {
  const userData = localStorage.getItem('userData')
  const previousData = userData ? JSON.parse(userData) : null

  if (!previousData) {
    const initialData = { position: currentPosition, date: new Date().toISOString() }
    localStorage.setItem('userData', JSON.stringify(initialData))

    return { difference: 0 }

  } else {
    const today = new Date().toISOString().substring(0, 10)
    const previousDate = new Date(previousData.date).toISOString().substring(0, 10)
    const difference = currentPosition - previousData.position

    if (today === previousDate && currentPosition !== previousData.position) {
      return { difference }
    } else {
      const newData = { position: currentPosition, date: new Date().toISOString() }
      localStorage.setItem('userData', JSON.stringify(newData))

      return { difference }
    }
  }
}

function statusPosition(X: number) {
  if (X === 0) {
    return { status: 'up', message: `Mantuvo su posición del ranking` }
  } else if (X > 0) {
    return { status: 'down', message: `Bajaste ${X} ${X === 1 ? 'posición' : 'posiciones'} del ranking` }
  } else {
    X = -X;
    return { status: 'up', message: `Subiste ${X} ${X === 1 ? 'posición' : 'posiciones'} del ranking` }
  }
}

// @ts-ignore
// window.diff = calcularDiferencia